import { type Response, sendGet, sendPost } from '../hooks/use-fetch'
import { type AddOrEditAnnualPlanSupportCostRequest, type TrackAnnualPlanSupportCostRequest } from '../models/requestObjects/rcn/supportCost/supportCostRequestObjects'
import type { SupportCost } from '../models/SupportCost'

const BASE_URL = 'SupportCost'

export async function AddSupportCost (costItem: AddOrEditAnnualPlanSupportCostRequest): Promise<Response> {
  return await sendPost(`${BASE_URL}/Add`, costItem)
}

export async function UpdateSupportCost (costItem: AddOrEditAnnualPlanSupportCostRequest): Promise<Response> {
  return await sendPost(`${BASE_URL}/Update`, costItem)
}

export async function TrackSupportCost (costItem: TrackAnnualPlanSupportCostRequest): Promise<Response> {
  return await sendPost(`${BASE_URL}/Track`, costItem)
}

export async function DeleteSupportCost (costItemId: number, isUpdate: boolean): Promise<Response> {
  return await sendPost(`${BASE_URL}/Delete?costItemId=${costItemId}&&isUpdate=${String(isUpdate)}`, {})
}

export async function ClearSupportCostTracking (request: { id: number }): Promise<Response> {
  return await sendPost(`${BASE_URL}/ClearTracking`, request)
}

export async function GetSupportCosts (annualPlanId: number, orgId: number, contractOnly: boolean): Promise<Response<SupportCost[]>> {
  return await sendGet(`${BASE_URL}/Get?annualPlanId=${annualPlanId}&&orgId=${orgId}&&contractOnly=${String(contractOnly)}`)
}
